import axios from 'axios/index';

// API key in SPA — rotate / move server-side later
// dev
// export const PVC_BASE_URL = 'http://localhost:3020/physical-voucher/';
// prod
// export const PVC_BASE_URL = 'https://general.api.selio.id/physical-voucher/'
export const PVC_BASE_URL = 'https://general.api.selio.id/physical-voucher/';
export const PVC_API_KEY = 'dev-api-key';

function pvcHeaders(businessId) {
    return {
        'x-api-key': PVC_API_KEY,
        'x-business-id': String(businessId),
        Accept: 'application/json'
    };
}

function pvcUrl(path) {
    return `${PVC_BASE_URL.replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
}

/**
 * @param {number} businessId GetDiskon business_id (positive integer)
 * @returns {Promise<true|false|null>} true = enrolled, false = not enrolled, null = check failed; do not cache
 */
export async function pvcResolveEnrollment(businessId) {
    if (!Number.isInteger(businessId) || businessId <= 0) return false;

    try {
        const { status, data } = await axios.get(pvcUrl('business/enrollment'), {
            headers: pvcHeaders(businessId),
            timeout: 10000,
            validateStatus: () => true
        });

        if (status !== 200 || !data || !('enrolled' in data)) return null;

        return !!data.enrolled;
    } catch {
        return null;
    }
}

/** Spread onto userData after enrollment check; null = do not cache. */
export function pvcEnrollmentPatch(enrolled) {
    return enrolled === null ? {} : { has_physical_voucher: enrolled };
}

/**
 * @returns {Promise<{ code_sets: Array }>}
 */
export function pvcListCodeSets(businessId) {
    return axios
        .get(pvcUrl('code-sets'), {
            headers: pvcHeaders(businessId)
        })
        .then(res => res.data);
}

/**
 * @returns {Promise<object>} lookup payload including pos_item_discount_ids
 */
export function pvcLookupCode(businessId, code) {
    return axios
        .get(pvcUrl('codes/lookup'), {
            params: { code },
            headers: pvcHeaders(businessId)
        })
        .then(res => res.data);
}

/**
 * @returns {Promise<object>}
 */
export function pvcRedeemCode(businessId, { code, pos_trx_id, used_by }) {
    return axios
        .post(
            pvcUrl('codes/redeem'),
            {
                code,
                pos_trx_id,
                ...(used_by ? { used_by } : {})
            },
            { headers: pvcHeaders(businessId) }
        )
        .then(res => res.data);
}
